import { NgModule, Injectable } from '@angular/core';
import {
  Routes,
  RouterModule,
  PreloadingStrategy,
  Route
} from '@angular/router';

import { LoadGuard } from './guards/load.guard';
import { MarketplaceGuardService } from './guards/marketplace-guard.service';
import { SeoGuard } from './guards/seo.guard';
import { Observable, of } from 'rxjs';

@Injectable()
export class SelectivePreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: Function): Observable<any> {
    return route.data && route.data.preload ? load() : of(null);
  }
} 

export const routes: Routes = [
  {
    path: '',
    // pathMatch: 'full',
    canLoad: [LoadGuard, MarketplaceGuardService],
    data: { type: 'fetchlocation', preload: true },
    canActivate: [LoadGuard, SeoGuard],
    loadChildren:() => import('../app/components/fetch-location/fetch-location.module').then(m => m.FetchLocationModule)
  },
  {
    path: 'stripe',
    loadChildren:() => import('../app/components/stripe/stripe.module').then(m=>m.StripeModule)
  }, 
  {
    path: '',
    data: { type: 'layout' },
    canLoad: [LoadGuard],
    loadChildren: () => import('../app/components/layout/layout.module').then(m=>m.LayoutModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      preloadingStrategy: SelectivePreloadingStrategy,
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
